var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import classNames from 'classnames';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
import { useAccurityTimezone } from '../../timezoneProvider/AccurityTimezoneProvider';
import { millisecondToISODate } from '../../common/utils';
var LATEST_REVISION_LABEL = 'Current';
export var VersionBrowserRevisionSelector = function (_a) {
    var allRevision = _a.allRevision, initialNewRevision = _a.initialNewRevision, initialOldRevision = _a.initialOldRevision, onChange = _a.onChange;
    var timezone = useAccurityTimezone();
    var _b = useState(initialOldRevision), oldRevision = _b[0], setOldRevision = _b[1];
    var _c = useState(initialNewRevision), newRevision = _c[0], setNewRevision = _c[1];
    // always sort revisions
    allRevision = allRevision.sort(function (a, b) { return a.revision - b.revision; });
    // old revisions do not contain newest item
    var oldRevisions = allRevision.slice(0, -1);
    var oldRevisionChangeHandler = function (e, revision) {
        setOldRevision(revision);
        if (onChange) {
            onChange(revision, newRevision);
        }
    };
    var newRevisionChangeHandler = function (e, revision) {
        setNewRevision(revision);
        if (onChange) {
            onChange(oldRevision, revision);
        }
    };
    var getOptionLabel = function (revision) {
        var idx = allRevision.indexOf(revision);
        return idx === allRevision.length - 1
            ? LATEST_REVISION_LABEL
            : idx + 1 + " - " + millisecondToISODate(revision.changedDate, timezone) + " by " + revision.username;
    };
    return (React.createElement("div", { className: classNames('versionBrowserRevisionSelector') },
        React.createElement(Autocomplete, { id: "versionBrowserRevisionSelector-olderRevision", options: oldRevisions, getOptionLabel: getOptionLabel, defaultValue: initialOldRevision, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { label: "Older version" })); }, disableClearable: true, onChange: oldRevisionChangeHandler, getOptionDisabled: function (revision) { return revision.revision >= newRevision.revision; }, blurOnSelect: true }),
        React.createElement(Autocomplete, { id: "versionBrowserRevisionSelector-newerRevision", options: allRevision, getOptionLabel: getOptionLabel, defaultValue: initialNewRevision, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { label: "Newer version" })); }, disableClearable: true, onChange: newRevisionChangeHandler, getOptionDisabled: function (revision) { return revision.revision <= oldRevision.revision; }, blurOnSelect: true })));
};
export default VersionBrowserRevisionSelector;
//# sourceMappingURL=VersionBrowserRevisionSelector.js.map